import { IconComponent } from 'design-system/types'

export const HomeIcon: IconComponent = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="m23.71 11.44-9.59-9.59c-1.13-1.13-3.11-1.13-4.24 0L.29 11.44a.996.996 0 1 0 1.41 1.41l9.59-9.59c.38-.38 1.04-.38 1.41 0l9.59 9.59c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41Z"
      fill="currentColor"
    />
    <path
      d="M20 13c-.55 0-1 .45-1 1v7h-3v-6c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6H5v-7c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-6h4v6c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1Z"
      fill="currentColor"
    />
  </svg>
)
